/**
 * Custom Select Component
 * Enhances native select elements with custom styling and behavior
 */

export default (node) => {
  const select = node.querySelector('select');
  if (!select) return;

  const variant = node.dataset.selectVariant || 'beige';

  // Add variant class if not already present
  if (!node.classList.contains(variant)) {
    node.classList.add(variant);
  }

  // Handle select change events
  const handleChange = () => {
    const event = new CustomEvent('selectChange', {
      detail: {
        value: select.value,
        name: select.name,
        selectedIndex: select.selectedIndex
      },
      bubbles: true
    });
    node.dispatchEvent(event);
  };

  select.addEventListener('change', handleChange);

  // Keyboard accessibility
  select.addEventListener('keydown', (e) => {
    // Allow Enter and Space to open select on some browsers
    if (e.key === 'Enter' || e.key === ' ') {
      if (!select.matches(':focus')) {
        select.focus();
      }
    }
  });

  // Update visual state based on selection
  const updateVisualState = () => {
    if (select.value === '' || select.selectedIndex === 0) {
      node.classList.add('no-selection');
    } else {
      node.classList.remove('no-selection');
    }
  };

  select.addEventListener('change', updateVisualState);
  updateVisualState(); // Initial state

  // Cleanup function (optional, for SPA-like behavior)
  return () => {
    select.removeEventListener('change', handleChange);
    select.removeEventListener('change', updateVisualState);
  };
};
